<template>
  <layout 
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:actions>
      <action-group>
        <message />
      </action-group>

      <action-group class="hidden sm:flex">
        <log-in-as />
      </action-group>
    </template>
  </layout>
</template>

<script>
import Layout from './Layout'
import ActionGroup from '@/components/Navbar/ActionGroup'
import Message from './Buttons/Message'
import LogInAs from './Buttons/LogInAs'

export default {
    components: {
        Layout,
        ActionGroup,
        Message,
        LogInAs,
    },
}
</script>